import { render, staticRenderFns } from "./redioButtonsBoolean.vue?vue&type=template&id=28846ca0&"
import script from "./redioButtonsBoolean.vue?vue&type=script&lang=js&"
export * from "./redioButtonsBoolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports